export enum ScaleParity {
  NO_PARITY = "No parity",
  ODD_PARITY = "Odd",
  EVEN_PARITY = "Even",
  MARK_PARITY = "Mark",
  SPACE_PARITY = "Space"
}
